import { AxiosResponse } from "axios"
import { useMutation } from "react-query"

import { ICustomerVehicle } from "types/customer"
import customersService from "api/customersService"

const useBlockUnblockCustomerMutation = () => {
  return useMutation(async (customerId: string) => {
    try {
      const res: AxiosResponse<Partial<ICustomerVehicle>> = await customersService.blockUnblockCustomer(customerId)

      return res.data
    } catch(err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useBlockUnblockCustomerMutation